export const filterOptionByLabel: (
    inputValue: string,
    options?: {
        value: string
        label: string
    }
) => boolean = (inputValue, option) => {
    return option!.label.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
}
